import { createContext, useState } from 'react';
import HpModal from '../Modal/HpModal';

export const PopupContext = createContext();

export const PopupProvider = ({ children }) => {
  const [popupData, setPopupData] = useState(null);
  const ContentComponent = popupData?.contentComponent;

  return (
    <PopupContext.Provider value={{ setPopupData }}>
      <HpModal
        open={!!popupData}
        toggle={() => setPopupData(null)}
        title={popupData?.title}
        body={ContentComponent ? <ContentComponent {...(popupData?.contentProps ?? {})} /> : null}
        size="xl"
      />
      {children}
    </PopupContext.Provider>
  );
};
